import React from 'react';
export const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/wyeeJtwvu1HiXsJKfGXny6/1.png';
export function BeatMark({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`relative flex items-center justify-center ${className}`} data-id="element-12" data-mp="1220qw1327mux">
      <img src={LOGO_URL} alt="BEAT Soda" className="h-auto w-full object-contain" data-id="element-13" data-mp="120674q3iy0sf" />
    </div>;
}